<template>
  <v-layout row wrap id="transaction_area">
    <v-flex sm12 md4 lg4 class="vertLine" v-if="orderType !== 1">
      <p class="body-2 font-weight-bold text-red">Danh sách mã đơn hàng</p>
      <v-list>
        <v-list-item-group v-model="selectedOrderCode" color="primary" mandatory>
          <v-list-item v-for="(item,index) in orderCodes" :key="item.ID">
            <v-list-item-content>
              <v-text-field v-model="item.OrderCodeCN" readonly class="no-boder"></v-text-field>
            </v-list-item-content>
            <v-list-item-action disabled>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                    :href="item.OrderCodeCN | transLink(siteName, orderId)"
                    target="_blank"
                    :disabled="!(orderEditRole & 8) || disabled || locked"
                  >
                    <v-icon color="yellow darken-3">local_shipping</v-icon>
                  </v-btn>
                </template>
                <span>Lấy mã vận đơn</span>
              </v-tooltip>
            </v-list-item-action>
            <v-list-item-action>
              <v-btn icon @click="removeOrderCode(index)" v-if="((orderEditRole & 8) && !disabled && orderCodeEditable && !purchaseRole && !locked) || adminRole">
                <v-icon>remove_circle</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-layout pl-2 row wrap align-center v-if="(orderEditRole & 8) && !disabled && !locked">
        <v-text-field
          label="Mã đơn hàng"
          v-model="newOrderCode.OrderCodeCN"
          class="input-group--focused mx-1 px-0 pt-0"
          @keyup.enter="addOrderCode()"
          :disabled="!(orderEditRole & 8) || disabled || !orderCodeEditable || locked"
        ></v-text-field>
        <v-btn icon @click="addOrderCode()" :disabled="!(orderEditRole & 8) || disabled || locked ||  !orderCodeEditable || newOrderCode.OrderCodeCN == ''">
          <v-icon color="#dc3545">add_circle</v-icon>
        </v-btn>
      </v-layout>
    </v-flex>
    <v-flex v-bind:class="{ 'sm12 md8 lg8': orderType !== 1, 'sm12 md12 lg12': orderType === 1}">
      <p class="body-2 font-weight-bold text-red">Danh sách mã vận đơn & cân nặng</p>
      <v-layout pl-2 row wrap align-center v-for="(item,index) in selectedTransCodes" :key="index">
        <v-text-field
          label="Mã vận đơn"
          v-model="item.OrderTransactionCode"
          class="input-group--focused mx-1 px-0"
          @change="editTransCode(item)"
          :readonly="((!(orderEditRole & 8) || disabled || !tranCodeEditable || checkPackageStatus(item.Status)) && !adminRole) || locked"
        ></v-text-field>
        <v-text-field
          label="Cân nặng"
          v-model="item.Weight"
          class="trans-weight input-group--focused mx-1 px-0"
          @change="editTransCode(item)"
          :disabled="((!(orderEditRole & 8) || disabled || checkPackageStatus(item.Status) || !weightEditable) && !adminRole) || locked"
        ></v-text-field>
        <v-select
          class="trans-status"
          label="Trạng thái"
          :items="transStatus"
          v-model="item.Status"
          item-disabled="disabled"
          item-value="value"
          item-text="name"
          @change="editTransCode(item)"
          :disabled="true"
        ></v-select>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click="printTransaction(item.Weight, item.OrderTransactionCode, customerName, orderId, item.NumberOfCode)">
              <v-icon color="red darken-2">print</v-icon>
            </v-btn>
          </template>
          <span>In tem</span>
        </v-tooltip>
        <v-btn icon @click="removeTransCode(index)" :disabled="((!(orderEditRole & 8) || disabled || !tranCodeEditable || checkPackageStatus(item.Status)) && !adminRole) || locked">
          <v-icon>remove_circle</v-icon>
        </v-btn>
      </v-layout>
      <v-layout pl-2 row wrap align-center v-if="(orderEditRole & 8) && !disabled && !locked && selectedOrderCode != -1">
        <v-text-field
          label="Mã vận đơn"
          v-model="newOrderTrans.OrderTransactionCode"
          class="input-group--focused mx-1 px-0"
          :disabled="!(orderEditRole & 8) || disabled || locked || !tranCodeEditable"
        ></v-text-field>
        <v-text-field
          label="Cân nặng"
          v-model="newOrderTrans.Weight"
          class="trans-weight input-group--focused mx-1 px-0"
          :disabled="!(orderEditRole & 8) || disabled || locked || !tranCodeEditable || !weightEditable"
        ></v-text-field>
        <v-select
          class="trans-status mr-3"
          label="Trạng thái"
          :items="transStatus"
          v-model="newOrderTrans.Status"
          item-disabled="disabled"
          item-value="value"
          item-text="name"
          :disabled="true"
        ></v-select>
        <v-btn icon @click="addTransCode()" class="ml-5" :disabled="!(orderEditRole & 8) || disabled || locked || !tranCodeEditable || newOrderTrans.OrderTransactionCode == ''">
          <v-icon color="#dc3545">add_circle</v-icon>
        </v-btn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import configs from "@/configs";
import _ from "lodash";
import { mapState } from "vuex";
import { display_date } from "@/commons/formater";
import { print_transaction } from "@/commons/hpod";
import moment from "moment";

export default {
  name: "order-transaction",
  filters: {
    transLink: function(value, siteName, orderId) {
      switch (siteName) {
        case "TAOBAO":
        case "TMALL":
          return `https://tradearchive.taobao.com/trade/detail/trade_item_detail.htm?bizOrderId=${value}&donhangchitietid=${orderId}`;
        case "1688":
          return `https://trade.1688.com/order/new_step_order_detail.htm?orderId=${value}&donhangchitietid=${orderId}#logisticsTabTitle`;
        default:
          return `https://tradearchive.taobao.com/trade/detail/trade_item_detail.htm?bizOrderId=${value}&donhangchitietid=${orderId}`;
      }
    }
  },
  props: {
    orderStatus: {
      type: Number,
      default: null
    },
    orderType: {
      type: Number,
      default: null
    },
    siteName: {
      type: String,
      default: "TAOBAO"
    },
    orderId: {
      type: Number,
      default: 0
    },
    customerName: {
      type: String,
      default: ""
    },
    customerID: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      transStatus: configs.PACKAGE_STATUS,
      showModalColumns: false,
      selectedOrderCode: -1,
      selectedTransCodes: [],
      newOrderCode: {
        Type: "order_code",
        OrderID: this.orderId,
        OrderCodeCN: "",
        CreatedDate: display_date(new Date(), configs.SQL_DATE_FORMAT),
        CreatedBy: this.$store.state.authentication.user.username
      },
      newOrderTrans: {
        Type: "transaction",
        OrderID: this.orderId,
        Username: this.customerName,
        UID: this.customerID,
        PackageType: this.orderType,
        OrderTransactionCode: "",
        Weight: 0.0,
        Status: configs.PACKAGE_STATUS_ENUM.DANG_DI_CHUYEN,
        CreatedDate: display_date(new Date(), configs.SQL_DATE_FORMAT),
        CreatedBy: this.$store.state.authentication.user.username
      }
    };
  },
  watch: {
    newOrderTrans() {
      this.newOrderTrans.Status =
        this.newOrderTrans.Weight > 0
          ? configs.PACKAGE_STATUS_ENUM.DA_VE_VN
          : configs.PACKAGE_STATUS_ENUM.DANG_DI_CHUYEN;
    },
    orderCodes() {
        this.selectedOrderCode = (this.selectedOrderCode == -1 || this.selectedOrderCode >= this.orderCodes.length) ? this.orderCodes.length - 1 : this.selectedOrderCode;
    },
    transCodes() {
        this.reloadSelectedTransCodes();
    },
    selectedOrderCode() {
        this.reloadSelectedTransCodes();
    }
  },
  methods: {
    reloadSelectedTransCodes() {
        if(this.orderType === 1) {
            this.selectedTransCodes = this.transCodes;
        }
        else if(this.selectedOrderCode > -1 && this.orderCodes.length > 0){
            this.selectedTransCodes = _.filter(this.transCodes, {'OrderCodeID': this.orderCodes[this.selectedOrderCode].ID});
        }
        else {
            this.selectedTransCodes = [];
        }
    },
    removeOrderCode(index) {
      const item = this.orderCodes[index];
      this.$store.dispatch("orderTransaction/deleteOrderTransaction", {
        type: "order_code",
        id: item.ID,
        orderId: item.OrderID,
        orderCode: item.OrderCodeCN,
        idx: index
      });
    },
    removeTransCode(index) {
      const item = this.selectedTransCodes[index];
      this.$store.dispatch("orderTransaction/deleteOrderTransaction", {
        type: "transaction",
        id: item.ID,
        orderId: item.OrderID,
        transactionCode: item.OrderTransactionCode,
        idx: index
      });
    },
    addOrderCode() {
      if(this.newOrderCode.OrderCodeCN == ''){
        return;
      }
      this.$store.dispatch(
        "orderTransaction/putOrderTransaction",
        this.newOrderCode
      );
      this.newOrderCode = {
        Type: "order_code",
        OrderID: this.orderId,
        OrderCodeCN: "",
        CreatedDate: display_date(new Date(), configs.SQL_DATE_FORMAT),
        CreatedBy: this.$store.state.authentication.user.username
      };
    },
    addTransCode() {
      if(this.newOrderTrans.OrderTransactionCode == ''){
        return;
      }
      this.newOrderTrans.Username = this.customerName;
      this.newOrderTrans.UID = this.customerID;
      if(this.orderType !== 1) {
          this.newOrderTrans.OrderCodeID = this.orderCodes[this.selectedOrderCode].ID;
      }
      
      this.newOrderTrans.Status =
        this.newOrderTrans.Weight > 0
          ? configs.PACKAGE_STATUS_ENUM.DA_VE_VN
          : configs.PACKAGE_STATUS_ENUM.DANG_DI_CHUYEN;
      this.$store.dispatch(
        "orderTransaction/putOrderTransaction",
        this.newOrderTrans
      );
      this.newOrderTrans = {
        Type: "transaction",
        OrderID: this.orderId,
        Username: this.customerName,
        UID: this.customerID,
        OrderTransactionCode: "",
		    PackageType: this.orderType,
        Weight: 0.0,
        Status: 1,
        CreatedDate: display_date(new Date(), configs.SQL_DATE_FORMAT),
        CreatedBy: this.$store.state.authentication.user.username
      };
    },
    editOrderCode(item) {
      var data = {
        ...item
      };
      data.Type = "order_code";
      data.ModifiedBy = this.$store.state.authentication.user.username;
      data.ModifiedDate = display_date(new Date(), configs.SQL_DATE_FORMAT);
      delete data.CreatedDate;
      delete data.CreatedBy;
      this.$store.dispatch("orderTransaction/postOrderTransaction", data);
    },
    editTransCode: _.debounce(
      function(item) {
        var data = {
          ...item
        };
        data.Type = "transaction";
        data.ModifiedBy = this.$store.state.authentication.user.username;
        data.ModifiedDate = display_date(new Date(), configs.SQL_DATE_FORMAT);
        item.Status = data.Status =
          data.Weight > 0
            ? configs.PACKAGE_STATUS_ENUM.DA_VE_VN
            : configs.PACKAGE_STATUS_ENUM.DANG_DI_CHUYEN;
        delete data.CreatedDate;
        delete data.CreatedBy;
        this.$store.dispatch("orderTransaction/postOrderTransaction", data);
      },
      500,
      {
        leading: false,
        trailing: true
      }
    ),
    fetchData: _.debounce(
      function() {
        this.$store.dispatch("orderTransaction/getOrderTransactionList", {
          order_id: this.orderId,
          package_type: this.orderType
        });
      },
      1000,
      {
        leading: true,
        trailing: false
      }
    ),
    printTransaction(weight, transactionCode, customerName, orderId, numberOfCode) {
      print_transaction(weight, transactionCode, customerName, orderId, numberOfCode);
    },
    checkPackageStatus(status) {
      return status == configs.PACKAGE_STATUS_ENUM.DA_VE_VN || status == configs.PACKAGE_STATUS_ENUM.KH_DA_NHAN;
    }
  },
  computed: {
    ...mapState("orderTransaction", {
      orderCodes: "orderCodes",
      transCodes: "transCodes"
    }),
    orderEditRole() {
      return this.$store.state.authentication.role.OrderEditable;
    },
    orderCodeEditable() {
      return (this.orderStatus != configs.ORDER_STATUS_ENUM.huy && this.orderStatus != configs.ORDER_STATUS_ENUM.hoan_thanh && this.orderStatus != configs.ORDER_STATUS_ENUM.da_thanh_toan) || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin == configs.ROLE_TYPE.Admin);
    },
    tranCodeEditable() {
      return (this.orderStatus != configs.ORDER_STATUS_ENUM.huy && this.orderStatus != configs.ORDER_STATUS_ENUM.hoan_thanh) || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin == configs.ROLE_TYPE.Admin);
    },
    weightEditable() {
      return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN);
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    purchaseRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
    },
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style scoped>
.trans-status {
  width: 180px;
}
.trans-weight {
  width: 60px;
}
.vertLine {
  border-right: 1px rgba(0, 0, 0, 0.12) !important;
  border-right-style: solid !important;
}
</style>
